import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {LabelFeature} from '../../../components/Labels';

export const TopElement = ({title, subTitle, labelTitle, labelLInk}) => {
  return (
    <div className={styles.top}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subTitle}>{subTitle}</div>
      <LabelFeature text={labelTitle} href={labelLInk} target="_blank" />
      <div className={clsx(styles.ellips)}></div>
      <div className={clsx(styles.ellips, styles.second)}></div>
      <div className={clsx(styles.ellips, styles.third)}></div>
    </div>
  );
};
